'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * shim layer with setTimeout fallback
 */
window.requestAnimationFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
}();

var _subscribers = {}; // list of subscriber callbacks
var _isRunning = false; // indicates if rAF is running
var _lastID = 1; // index for client id
var _prefix = 'RAF_'; // prefix for client id

/*
 * Update all subscribers
 */
var _updateSubscribers = function _updateSubscribers() {
  for (var id in _subscribers) {
    _subscribers[id]();
  }
};

/*
 * Enter frame tick
 */
var _tick = function _tick() {
  _updateSubscribers();
  if (_isRunning) window.requestAnimationFrame(_tick);
};

/**
* Global request animation frame implementation that objects can subscribe to
* @module
*/

var Raf = function () {
  function Raf() {
    _classCallCheck(this, Raf);
  }

  _createClass(Raf, [{
    key: 'subscribe',

    /**
     * Subscribe to enter frame tick
     * @param  {Function}   callback  Callback function called on tick
     * @return {String}               Client id
     */
    value: function subscribe(callback) {
      if (typeof callback !== 'function') return;

      var id = _prefix + _lastID++;
      _subscribers[id] = callback;
      this.start();
      return id;
    }

    /**
     * Unsubscribe from tick
     * @param  {String} id Client id that was previously return on subscription
     */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe(id) {
      if (_subscribers[id]) {
        delete _subscribers[id];
      }
    }

    /**
     * Starts enter frame tick
     */

  }, {
    key: 'start',
    value: function start() {
      if (_subscribers.length < 1 || _isRunning) return; // no elements or already running -> don't do anything
      _isRunning = true;
      _tick();
    }

    /**
     * Stops enter frame tick
     */

  }, {
    key: 'stop',
    value: function stop() {
      _isRunning = false;
    }
  }]);

  return Raf;
}();

var raf = new Raf();

exports.default = raf;


//////////////////
// WEBPACK FOOTER
// ./src/lib/Raf.js
// module id = 355
// module chunks = 1